
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer/api-stability",
      function () {
        return require("private-next-pages/developer/api-stability.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer/api-stability"])
      });
    }
  